import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface AppHeaderState {
  showSponsorDropdown: boolean;
  sponsors: string[];
  selectedSponsor: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppHeaderService {
  private headerState$ = new BehaviorSubject<AppHeaderState>({
    showSponsorDropdown: true,
    sponsors: [],
    selectedSponsor: 'All'
  });

  private sponsorApplied$ = new Subject<string>();

  getHeaderState(): Observable<AppHeaderState> {
    return this.headerState$.asObservable();
  }

  getCurrentHeaderState(): AppHeaderState {
    return this.headerState$.value;
  }

  updateHeaderState(state: Partial<AppHeaderState>): void {
    this.headerState$.next({
      ...this.headerState$.value,
      ...state
    });
  }

  getSponsorApplied(): Observable<string> {
    return this.sponsorApplied$.asObservable();
  }

  emitSponsorApplied(sponsor: string): void {
    this.sponsorApplied$.next(sponsor);
  }
}
